import React, { useId } from 'react';
import { Avatar } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolveTeamCrest } from '../EquipoExecutiveHeader';
import { reportSum, reportTeamMetrics } from '../../utils/rivalReport';

export default function TeamStatisticsHeader({ team, statistics, standing, calendar, season, competition, group,
  classificationTo, onClassificationClick }) {
  const { t, i18n } = useTranslation('stats');
  const titleId = useId();
  const metrics = reportTeamMetrics(statistics, standing);
  const format = value => (value ?? 0).toLocaleString(i18n.language, { maximumFractionDigits: 1 });
  const name = team?.nombre || standing?.nombre || statistics?.nombre || t('teams.modern.team');
  const goalsFor = metrics.goalsFor ?? reportSum(...['golesTotales', 'golesTotalesPenalti', 'golesTotalesPropia']
    .map(key => statistics?.goles?.[key] ?? 0)) ?? 0;
  const goalsAgainst = metrics.goalsAgainst ?? reportSum(...['golesTotalesRecibidos', 'golesTotalesRecibidosPenalti', 'golesTotalesRecibidosPropia']
    .map(key => statistics?.goles?.[key] ?? 0)) ?? 0;
  const difference = goalsFor - goalsAgainst;
  const kpis = [
    ['position', metrics.position > 0 ? `${format(metrics.position)}º` : '0', t('teams.modern.groupPosition')],
    ['points', format(metrics.points), t('teams.modern.sample', { count: metrics.played ?? 0 })],
    ['wins', format(metrics.wins), `${format(metrics.winRate !== null && metrics.winRate <= 100 ? metrics.winRate : 0)}%`],
    ['goalDifference', `${difference > 0 ? '+' : ''}${format(difference)}`,
      `${format(goalsFor)} / ${format(goalsAgainst)}`],
  ];
  return <section className="ts-hero" aria-labelledby={titleId} data-testid="team-executive-header">
    <div className="ts-identity">
      <Avatar className="ts-crest" src={resolveTeamCrest(team, statistics, standing, calendar)} alt="">
        {name[0]}
      </Avatar>
      <div><span className="rr-eyebrow">{t('teams.modern.eyebrow')}</span><h1 id={titleId}>{name}</h1>
        <div className="ts-context">
          {competition && <span>{competition}</span>}
          {group && <span>{group}</span>}
          {season && <span>{t('teams.modern.season', { season })}</span>}
        </div>
      </div>
    </div>
    <dl className="ts-kpis">{kpis.map(([key, value, helper]) => <div key={key}>
      <dt>{key === 'position' && classificationTo
        ? <Link className="ts-position-link" to={classificationTo} onClick={onClassificationClick}>
          {t('teams.modern.position')}<span>{t('teams.modern.viewStandings')}<ArrowForward fontSize="inherit" /></span>
        </Link> : t(`teams.modern.${key}`)}</dt><dd>{value}</dd><small>{helper}</small>
    </div>)}</dl>
  </section>;
}
